export default __webpack_public_path__ + "static/media/02.01326747.jpg";